import Shortcode, { RecursiveShortcodeProps } from './Shortcode';

// TODO: help.. please.
export type ShortcodeProps = RecursiveShortcodeProps;

export default Shortcode;
